<script>
import axios from 'axios';

export default {
    data() {
        return {
            version: {
                app: import.meta.env.VITE_APP_VERSION,
                api: '...'
            },
            loaded: false
        }
    },
    methods: {
        getVersion() {
            axios.get('version').then(resp => {
                this.version.api = resp.data.version;
                this.loaded = true;
            })
        }
    },
    created() {
        this.getVersion();
    }
}
</script>

<template>
    <p v-if="loaded">Interface version: {{ version.app }}, API version: {{ version.api }}</p>
    <p v-else>...</p>
</template>